export default __webpack_public_path__ + "e05c4f5c259f07796cf84bfb9f0c475a.png";